import { Component, Input, OnInit } from '@angular/core';
import { mizVideoFinder, videos_json, count_tedadeDars, count_tedadeGhesmat } from 'src/app/video-data/videos';
import { ActivatedRoute, Router } from '@angular/router';


type ghesmat = {
  onvan: string;
  shenase: string;
}

@Component({
  selector: 'payeha',
  templateUrl: './payeha.component.html',
  styleUrls: ['payeha.component.scss'],
})
export class PayehaComponent implements OnInit {
  videoFinder = function mizVideoFinder(paye: number, fasl: number, dars: number, ghesmat: number): ghesmat { return };
  count_tedadeDars = function count_tedadeDars(shomareyePaye: number, shomareyeFasl: number): number { return };
  count_tedadeGhesmat = function count_tedadeGhesmat(shomareyePaye: number, shomareyeFasl: number, shomareyeDars: number): number { return };
  videos_json;
  @Input() respectfulName;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

    this.videoFinder = mizVideoFinder;
    this.count_tedadeDars = count_tedadeDars;
    this.count_tedadeGhesmat = count_tedadeGhesmat;
    this.videos_json = videos_json;
  }

  queryParams: { paye: number, fasl: number, dars: number } = { paye: -1, fasl: -1, dars: -1 };
  ngOnInit() {
    // this.navigate(); برای آزمایش
    // read query params---
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams['paye'] = Number(params['paye']);
      this.queryParams['fasl'] = Number(params['fasl']);
      this.queryParams['dars'] = Number(params['dars']);
      console.log(this.queryParams);
    })
  }


  //... ( 'OgfJQ' --> مثال شناسه برای آزمایش  )
  shenase: string;
  videoShowComponent_isShowing: boolean = false;
  show_videoShowComponent(inputShenase: string) {
    this.shenase = inputShenase;
    this.videoShowComponent_isShowing = true;
  }

  numToArray(input: number): Array<number> {
    let tempArr = [];
    for (let i = 1; i <= input; i = i + 1) {
      tempArr.push(i);
    }
    return tempArr;
  }

  numToFa(str: string) {
    str = str.toString();
    let splited_and_converted: Array<string> = [];
    [...str].forEach(char => {
      splited_and_converted.push(
        {
          '0': '۰',
          '1': '۱',
          '2': '۲',
          '3': '۳',
          '4': '۴',
          '5': '۵',
          '6': '۶',
          '7': '۷',
          '8': '۸',
          '9': '۹',
        }[char]
      );
    });
    return splited_and_converted.join('');
  }


  activatedShenase: string;
  saveActiavatedShenase(event: any) {
    this.activatedShenase = event.shenase;
    console.log('شناسه خروجی از ویدیو', event.shenase);
  }


  navigate() {
    this.router.navigate([], { queryParams: { paye: 8, fasl: 3, dars: 2 }, })
  }

  wouldThisPayeBeOpen(paye: number): boolean {
    return (paye == this.queryParams['paye']); //true
  }
  wouldThisFaslBeOpen(paye: number, fasl: number): boolean {
    return (paye == this.queryParams['paye'])
      && (fasl == this.queryParams['fasl']);
  }
  wouldThisDarsBeOpen(paye: number, fasl: number, dars: number): boolean {
    return (paye == this.queryParams['paye'])
      && (fasl == this.queryParams['fasl'])
      && (dars == this.queryParams['dars']);
  }

  scroll(el: HTMLElement) {
    this.log(el)
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  log(input) {
    console.log(input)
  }
}
